export const TRANSFER_TYPE_FAIL_REVERSAL_BROKER_TO_BROKER_ONLY =
  'FAIL_REVERSAL_BROKER_TO_BROKER_ONLY'
export const TRANSFER_TYPE_FULL_TRANSFER = 'FULL_TRANSFER'
export const TRANSFER_TYPE_MUTUAL_FUND_CLEANUP = 'MUTUAL_FUND_CLEANUP'
export const TRANSFER_TYPE_PARTIAL_TRANSFER_DELIVERER =
  'PARTIAL_TRANSFER_DELIVERER'
export const TRANSFER_TYPE_PARTIAL_TRANSFER_RECEIVER =
  'PARTIAL_TRANSFER_RECEIVER'
export const TRANSFER_TYPE_POSITION_TRANSFER_FUND_FIRM_TO_MUTUAL_FUND_COMPANY_ONLY =
  'POSITION_TRANSFER_FUND_FIRM_TO_MUTUAL_FUND_COMPANY_ONLY'
export const TRANSFER_TYPE_RECLAIM = 'RECLAIM'
export const TRANSFER_TYPE_RESIDUAL_CREDIT = 'RESIDUAL_CREDIT'
export const TRANSFER_TYPE_UNDEFINED = 'UNDEFINED'

export const PROCESSING_DIRECTION_INTERNAL = 'INTERNAL'
export const PROCESSING_DIRECTION_JOINING = 'JOINING'
export const PROCESSING_DIRECTION_LEAVING = 'LEAVING'
export const PROCESSING_DIRECTION_INCOMING = PROCESSING_DIRECTION_JOINING
export const PROCESSING_DIRECTION_OUTGOING = PROCESSING_DIRECTION_LEAVING

export const NSCC_STATUS_REQUEST = 'REQUEST'
export const NSCC_STATUS_REQUEST_ADJUST = 'REQUEST_ADJUST'
export const NSCC_STATUS_REQUEST_ADJUST_PAST = 'REQUEST_ADJUST_PAST'
export const NSCC_STATUS_REQUEST_PAST = 'REQUEST_PAST'
export const NSCC_STATUS_REQUEST_REJECT = 'REQUEST_REJECT'
export const NSCC_STATUS_REVIEW = 'REVIEW'
export const NSCC_STATUS_REVIEW_ADJUST_DELIVERER = 'REVIEW_ADJUST_DELIVERER'
export const NSCC_STATUS_REVIEW_ERROR = 'REVIEW_ERROR'
export const NSCC_STATUS_REVIEW_ACCELERATE = 'REVIEW_ACCELERATE'
export const NSCC_STATUS_REVIEW_ADJUST_RECEIVER_ACCELERATE =
  'REVIEW_ADJUST_RECEIVER_ACCELERATE'
export const NSCC_STATUS_SETTLE_PREP = 'SETTLE_PREP'
export const NSCC_STATUS_SETTLE_CLOSE = 'SETTLE_CLOSE'
export const NSCC_STATUS_CLOSE_PURGE = 'CLOSE_PURGE'
export const NSCC_STATUS_REQUEST_500 = 'REQUEST_500'
export const NSCC_STATUS_MEMO_PURGE_PARTIAL_TRANSFER_REQUEST_RECEIVER =
  'MEMO_PURGE_PARTIAL_TRANSFER_REQUEST_RECEIVER'
export const NSCC_STATUS_REJECT = 'REJECT'
export const NSCC_STATUS_SYSTEM_PURGE = 'SYSTEM_PURGE'
export const NSCC_STATUS_UNDEFINED = 'UNDEFINED'
export const NSCC_STATUS_PARTIAL_REQUEST = 'PARTIAL_REQUEST'

export const ALPS_RECOMMENDED_ACTION_NONE = 'NONE'
export const ALPS_RECOMMENDED_ACTION_ACCEPT_ASSETS = 'ACCEPT_ASSETS'
export const ALPS_RECOMMENDED_ACTION_ATTACH_ASSETS = 'ATTACH_ASSETS'
export const ALPS_RECOMMENDED_ACTION_REJECT = 'REJECT'
export const ALPS_RECOMMENDED_ACTION_RESUBMIT = 'RESUBMIT'
export const ALPS_RECOMMENDED_ACTION_INITIATE = 'INITIATE'
export const ALPS_RECOMMENDED_ACTION_ADD_ASSET = 'ADD_ASSET'
export const ALPS_RECOMMENDED_ACTION_DELETE_ASSET = 'DELETE_ASSET'
export const ALPS_RECOMMENDED_ACTION_ADJUST_ASSET = 'ADJUST_ASSET'
export const ALPS_RECOMMENDED_ACTION_PURGE = 'PURGE'
export const ALPS_RECOMMENDED_ACTION_REJECT_SSN_TAX_ID_MISMATCH =
  'REJECT_SSN_TAX_ID_MISMATCH'
export const ALPS_RECOMMENDED_ACTION_REJECT_ACCOUNT_TITLE_MISMATCH =
  'REJECT_ACCOUNT_TITLE_MISMATCH'
export const ALPS_RECOMMENDED_ACTION_REJECT_DOCUMENTATION_NEEDED =
  'REJECT_DOCUMENTATION_NEEDED'
export const ALPS_RECOMMENDED_ACTION_REJECT_ACCOUNT_FLAT = 'REJECT_ACCOUNT_FLAT'
export const ALPS_RECOMMENDED_ACTION_REJECT_INVALID_ACCOUNT_NUMBER =
  'REJECT_INVALID_ACCOUNT_NUMBER'
export const ALPS_RECOMMENDED_ACTION_REJECT_DUPLICATE = 'REJECT_DUPLICATE'
export const ALPS_RECOMMENDED_ACTION_REJECT_ACCOUNT_IN_DISTRIBUTION_OR_TRANSFER =
  'REJECT_ACCOUNT_IN_DISTRIBUTION_OR_TRANSFER'
export const ALPS_RECOMMENDED_ACTION_REJECT_CLIENT_RESCINDED =
  'REJECT_CLIENT_RESCINDED'
export const ALPS_RECOMMENDED_ACTION_REJECT_MISSING_AUTHORIZATION_SIGNATURE =
  'REJECT_MISSING_AUTHORIZATION_SIGNATURE'
export const ALPS_RECOMMENDED_ACTION_REJECT_CREDIT_POLICY_VIOLATION =
  'REJECT_CREDIT_POLICY_VIOLATION'
export const ALPS_RECOMMENDED_ACTION_REJECT_CREDIT_POLICY_VIOLATION_HARD =
  'REJECT_CREDIT_POLICY_VIOLATION_HARD'
export const ALPS_RECOMMENDED_ACTION_REJECT_UNRECOGNIZED_FOR_RESIDUAL_CREDIT_BALANCE =
  'REJECT_UNRECOGNIZED_FOR_RESIDUAL_CREDIT_BALANCE'
export const ALPS_RECOMMENDED_ACTION_REJECT_PARTIAL_TRANSFER_DELIVERER_INITIATED_REJECT =
  'REJECT_PARTIAL_TRANSFER_DELIVERER_INITIATED_REJECT'
export const ALPS_RECOMMENDED_ACTION_REJECT_FAIL_REVERSAL_REJECT =
  'REJECT_FAIL_REVERSAL_REJECT'
export const ALPS_RECOMMENDED_ACTION_REJECT_RECLAIM_REJECT =
  'REJECT_RECLAIM_REJECT'
export const ALPS_RECOMMENDED_ACTION_REJECT_MUTUAL_FUND_CLEANUP_REJECT =
  'REJECT_MUTUAL_FUND_CLEANUP_REJECT'
export const ALPS_RECOMMENDED_ACTION_ACCEPT = 'ACCEPT'
export const ALPS_RECOMMENDED_ACTION_ACCELERATE = 'ACCELERATE'
export const ALPS_RECOMMENDED_ACTION_WAITING_ON_CONTRA_PARTY =
  'WAITING_ON_CONTRA_PARTY'
export const ALPS_RECOMMENDED_ACTION_WAITING_ON_NSCC = 'WAITING_ON_NSCC'
export const ALPS_RECOMMENDED_ACTION_SUBMIT_FR = 'SUBMIT_FR'

export const ALPS_STATUS_INITIAL = 'INITIAL'
export const ALPS_STATUS_CONTRA_PARTY = 'CONTRA_PARTY'
export const ALPS_STATUS_NSCC = 'NSCC'
export const ALPS_STATUS_FINISHED = 'FINISHED'
export const ALPS_STATUS_REQUEST_ALPS_APPROVAL = 'REQUEST_ALPS_APPROVAL'
export const ALPS_STATUS_REQUEST_MARGINS_APPROVAL = 'REQUEST_MARGINS_APPROVAL'
export const ALPS_STATUS_REVIEW_ERROR = 'REVIEW_ERROR'
export const ALPS_STATUS_SETTLING = 'SETTLING'
export const ALPS_STATUS_CREATE_SWEEPING_REQUEST = 'CREATE_SWEEPING_REQUEST'
export const ALPS_STATUS_INVALID_LEGACY = 'INVALID_LEGACY'
export const ALPS_STATUS_CREATE_REQUEST = 'CREATE_REQUEST'
export const ALPS_STATUS_REQUEST_ERROR = 'REQUEST_ERROR'
export const ALPS_STATUS_REVIEW_ALPS_APPROVAL = 'REVIEW_ALPS_APPROVAL'
export const ALPS_STATUS_REVIEW_MARGIN_APPROVAL = 'REVIEW_MARGIN_APPROVAL'
export const ALPS_STATUS_REQUEST_CONTRA_PARTY_APPROVAL =
  'REQUEST_CONTRA_PARTY_APPROVAL'
export const ALPS_STATUS_ERROR = 'ERROR'
export const ALPS_STATUS_TRANSFER_COMPLETE = 'TRANSFER_COMPLETE'
export const ALPS_STATUS_REGISTERING_FUNDS = 'REGISTERING_FUNDS'

export const REJECT_REASON_NONE = 'NONE'
export const REJECT_REASON_SSN_TAX_ID = 'SSN_TAX_ID'
export const REJECT_REASON_ACCOUNT_TITLE = 'ACCOUNT_TITLE'
export const REJECT_REASON_DOCUMENTATION_MISSING = 'DOCUMENTATION_MISSING'
export const REJECT_REASON_ACCOUNT_FLAT = 'ACCOUNT_FLAT'
export const REJECT_REASON_ACCOUNT_NUMBER = 'ACCOUNT_NUMBER'
export const REJECT_REASON_DUPLICATE = 'DUPLICATE'
export const REJECT_REASON_IN_DISTRIBUTION_OR_TRANSFER =
  'IN_DISTRIBUTION_OR_TRANSFER'
export const REJECT_REASON_CLIENT_RESCINDED = 'CLIENT_RESCINDED'
export const REJECT_REASON_AUTHORIZATION_SIGNATURE_MISSING =
  'AUTHORIZATION_SIGNATURE_MISSING'
export const REJECT_REASON_POSITION_TRANSFER_FUND = 'POSITION_TRANSFER_FUND'
export const REJECT_REASON_CREDIT_POLICY_VIOLATION = 'CREDIT_POLICY_VIOLATION'
export const REJECT_REASON_RCR_REJECT = 'RCR_REJECT'
export const REJECT_REASON_PTD_REJECT = 'PTD_REJECT'
export const REJECT_REASON_FRV_REJECT = 'FRV_REJECT'
export const REJECT_REASON_RCL_REJECT = 'RCL_REJECT'
export const REJECT_REASON_MFC_REJECT = 'MFC_REJECT'
export const REJECT_REASON_PTF_REJECT = 'PTF_REJECT'
export const REJECT_REASON_NSCC_REJECT = 'NSCC_REJECT'

// These looks remarkably similar to their reject reason counterparts.
// however the resolution service uses different constants.
export const ACAT_RESOLUTIONS_REJECT_REASON_DOCUMENTATION_NEEDED =
  'DOCUMENTATION_NEEDED'
export const ACAT_RESOLUTIONS_REJECT_REASON_CLIENT_RESCINDED =
  'CLIENT_RESCINDED'
export const ACAT_RESOLUTIONS_REJECT_REASON_PARTIAL_TRANSFER_DELIVERER_INITIATED_REJECT =
  'PARTIAL_TRANSFER_DELIVERER_INITIATED_REJECT'
export const ACAT_RESOLUTIONS_REJECT_REASON_MISSING_AUTHORIZATION_SIGNATURE =
  'MISSING_AUTHORIZATION_SIGNATURE'
export const ACAT_RESOLUTIONS_REJECT_REASON_CREDIT_POLICY_VIOLATED =
  'CREDIT_POLICY_VIOLATED'
